import Vue from 'vue'

Vue.filter('money', (value) => {
  return parseFloat(value)
    .toFixed(2)
    .replace(/\./g, ',')
    .replace(/\d(?=(\d{3})+,)/g, '$&.')
})
